export const AssetGeneration = {

	Name: "Asset Generation",

	Libraries: [],

	Events: {

	},

	Actions: {

		"GenerationsByHierarchy": function(generationsByHierarchy, data) {

			if (data.GenerationsCreativeId) this.clearCreativeGenerations(data.GenerationsCreativeId);

			_.each(generationsByHierarchy, assetGenerations => {
				_.each(assetGenerations, generation => {

					this.setGeneration(generation, generation.id, !data.GenerationsCreativeId);

				});
			});

			if (data.GenerationsCreativeId) Broadcast.call("Creative Generations Loaded", [data.GenerationsCreativeId]);
			else if (data.GenerationsCreativeId === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Generations Loaded");

		},

		"Generation": function(generation, data) {

			this.setGeneration(generation, data.GenerationId); // GenerationId нужен потому что generation может быть null - что означает что генерацию нужно удалить с клиента

		},

		"UserGenerationPrompts": function(userGenerationPrompts) {

			this.setUserGenerationPrompts(userGenerationPrompts); // GenerationId нужен потому что generation может быть null - что означает что генерацию нужно удалить с клиента

		},

	},

	init() {

		this.Generations = {}; // Хэш по id события
		this.GenerationsByHierarchy = {}; // группировка по id креатива -> codename ассета -> id генерации

		this.UserGenerationPrompts = [];

	},

	getCreativeGenerations(creativeId) {

		let result = [];

		this.forEachCreativeGenerations(creativeId, generation => {

			// Ошибки отображаем только 5 минут
			if (generation.status === 'error' && Date.now() - generation['start_time'] > 30 * 1000) return;

			result.push(generation);

		});

		result = _.orderBy(result, 'start_time', 'desc');

		return result;

	},

	getGenerationsMoneySpentByUsers(creativeId) {

		let result = {};

		this.forEachCreativeGenerations(creativeId, generation => {

			if (!result[generation["user_id"]]) result[generation["user_id"]] = {
				id: generation["user_id"],
				name: User.getUser(generation["user_id"])?.name,
				cost: 0,
				count: 0
			};

			result[generation["user_id"]].cost += generation["cost"];
			result[generation["user_id"]].count ++;

		});

		return result;

	},

	setGeneration(generation, generationId = null, isBroadcast = true) {

		let oldGeneration = this.Generations[generationId];

		if (generation) {

			this.Generations[generation.id] = generation;

			if (!this.GenerationsByHierarchy[generation['creative_id']]) this.GenerationsByHierarchy[generation['creative_id']] = {};
			if (!this.GenerationsByHierarchy[generation['creative_id']][generation['asset_codename']]) this.GenerationsByHierarchy[generation['creative_id']][generation['asset_codename']] = {};
			this.GenerationsByHierarchy[generation['creative_id']][generation['asset_codename']][generation.id] = generation;

			generation['start_time'] = new Date(generation['start_time']);
			generation['end_time'] = new Date(generation['end_time']);

		} else if (oldGeneration) {

			delete this.Generations[oldGeneration.id];

			if (this.GenerationsByHierarchy[oldGeneration?.['creative_id']]?.[oldGeneration?.['asset_codename']]) delete this.GenerationsByHierarchy[oldGeneration['creative_id']][oldGeneration['asset_codename']][generationId];

		}

		if (isBroadcast) {

			let generationPrefixes = ["Generation"];
			if (oldGeneration?.["creative_id"] === Creative.SelectedCreative?.id || generation?.["creative_id"] === Creative.SelectedCreative?.id) generationPrefixes.push("Selected Creative Generation");

			// Определяем автоматически изменения в объектах и запускаем соответствующие события
			this.broadcastChanges(oldGeneration, generation, generationPrefixes);

		}

	},

	setUserGenerationPrompts(userGenerationPrompts) {

		this.UserGenerationPrompts = userGenerationPrompts;

	},

	clearCreativeGenerations(creativeId) {

		_.each(this.Generations, generation => {

			if (generation["creative_id"] === creativeId) delete this.Generations[generation.id];

		});

		if (this.GenerationsByHierarchy[creativeId]) delete this.GenerationsByHierarchy[creativeId];

	},

	forEachCreativeGenerations(creativeId, callback) {

		_.each(this.GenerationsByHierarchy[creativeId], assetGenerations => {
			_.each(assetGenerations, generation => {

				callback(generation);

			});
		});

	}

};

